import Sku from './NewSku'
export default Sku
